import { useState } from 'react'
import { Helmet } from 'react-helmet'

import { MarketingCarrierLogos } from '../marketing/components/MarketingCarrierLogos'
import { AboutCaiFaq } from './AboutCaiFaq'
import { ConfirmEmailPanel } from './ConfirmEmailPanel'
import { IntelligentInsuranceSection } from './IntelligentInsuranceSection'
import { LargeFleetHero, PACKET_FORM_ID } from './LargeFleetHero'
import { PacketSubmitForm } from './PacketSubmitForm'

/** Public large-fleet lead-gen page — does not create or supplant an existing application. */
export function LargeFleetPage() {
  const [submitted, setSubmitted] = useState<{ email: string } | undefined>(undefined)

  return (
    <>
      <Helmet>
        <title>Large fleet insurance</title>
      </Helmet>
      <div className="bg-ink-850 flex flex-1 flex-col">
        {!submitted && (
          <>
            <LargeFleetHero />
            <section className="border-ink-700 border-b">
              <MarketingCarrierLogos
                onDark
                heading="Shop the nation's leading commercial insurance providers"
              />
            </section>
          </>
        )}
        <main
          id={PACKET_FORM_ID}
          className="mx-auto w-full max-w-(--maxw) flex-1 px-4 py-16 sm:px-6 lg:py-24"
        >
          {submitted ? (
            <ConfirmEmailPanel email={submitted.email} />
          ) : (
            <PacketSubmitForm onSubmitted={(email) => setSubmitted({ email })} />
          )}
        </main>
        {!submitted && (
          <>
            <IntelligentInsuranceSection />
            <AboutCaiFaq />
          </>
        )}
      </div>
    </>
  )
}
